<template>
	<div class="page-good page">
		<div class="wrapper">
			<!-- 主功能区 -->
			<noscript>
				<iframe sandbox="allow-scripts allow-same-origin" ref="ifrm" id="ifrm" :src="srcData" width="0" height="0"></iframe>
			</noscript>
			<div class="fun" >
				<div class="titleView">
					<div class="mr">
						<el-input size="small" style="width: 200px;" class="input-with-select" placeholder="商品名称/条码等" v-model="params.keywords" @change="searchGoods">
							
						</el-input>
						<el-button size="small" style="margin-left: 10px;" type="warning">搜索</el-button>
						<!-- <el-button  icon="el-icon-search iconsousuo" @click="searchGoods"></el-button> -->
					</div>
					<div class="mr">
						条码状态:
						<el-select size="small" clearable class="input" v-model="params.customCodeStatus" placeholder="选择条码状态" @change="searchGoods">
							<el-option :label="item.lable" :value="item.value" v-for="item in customCodeStatus" :key="item.label"></el-option>
						</el-select>
					</div>
					<div class="mr">
						门店:
						<el-select size="small" clearable v-model="params.ShopId" placeholder="选择门店" @change="searchGoods">
							<el-option :label="item.shop_name" :value="item.shop_id" v-for="item in $store.state.allShopList" :key="item.shop_id"></el-option>
						</el-select>
					</div>
					<div style="text-align: right;flex: 1;">
						<el-button size="small" type="warning" class="btn" icon="el-icon-delete" @click="lostCustom(selectCustomData)">丢失</el-button>
						<el-button size="small" type="warning" class="btn" icon="el-icon-check" @click="reductionCustom(selectCustomData)">还原</el-button>
						<el-button size="small" type="warning" class="btn" icon="el-icon-toilet-paper" @click="printCustom(selectCustomData)">打印条码</el-button>
					</div>
				</div>
			</div>

			
			<div class="table">
				<el-table @selection-change="selectionChange"  ref="table" row-class-name="row-expand-cove"
				:default-expand-all="false" :data="goodData.data" style="width: 100%" size="small">
					<el-table-column type="selection" width="50"></el-table-column>
					<el-table-column label-class-name="lablename" min-width="118px" label="条码" prop="customCode" width="110">
					</el-table-column>
					<el-table-column label-class-name="lablename" label="名称" prop="goodsName"></el-table-column>
					<el-table-column label-class-name="lablename" label="规格" prop="skuValue"></el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="单位" prop="unit" width="60"></el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="所在门店" prop="currentShopName"></el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="供应商" prop="supplierName" width="80"></el-table-column>
					<el-table-column align="center" label-class-name="lablename" sortable label="总次数" prop="totaTimes" width="80"></el-table-column>
					<el-table-column align="center" label-class-name="lablename" sortable label="已使用次数" prop="useTimes" width="110"></el-table-column>
					<el-table-column align="center" label-class-name="lablename" sortable label="过期时间" prop="validityStopDate" width="100">
						<template slot-scope="scope">
							<span>{{$public.FTime(scope.row.validityStopDate,'YYYY-MM-DD')}}</span>

						</template>
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="状态" prop="customCodeStatus.name" width="80"></el-table-column>
					<el-table-column type="expand" width="1">
						<template slot-scope="props">
							<el-timeline>
								<el-timeline-item v-for="(activity, index) in props.row.rowItemDetail" :key="index" size="large" :timestamp="$public.FTime(activity.trackTime)">{{activity.trackDesc}}</el-timeline-item>
							</el-timeline>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="120px">
						<template slot-scope="scope">
							<el-button v-if="scope.row.customCodeStatus.id !=0" icon="el-icon-view" type="text" @click="toogleExpand(scope.row)" size="small">追踪</el-button>
							<el-button v-if="scope.row.customCodeStatus.id !=0" icon="el-icon-edit" type="text" @click="editCustomCode(scope.row)" size="small">编辑</el-button>
							<el-button v-if="(scope.row.totaTimes - scope.row.useTimes)>1" type="text" icon="el-icon-scissors" @click="splitCustomCode(scope.row)" size="small">拆分</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="footer" v-if="goodData.count>params.pageSize" style="text-align: right;">
			<div></div>
			<div class="paging" style="background: #fff;padding: 10px 0;">
				<el-pagination :hide-on-single-page="goodData.count<params.pageSize" @current-change="handleCurrentChange"
				:current-page="params.pageIndex" :page-size="params.pageSize" layout="total, prev, pager, next, jumper" :total="goodData.count"></el-pagination>
			</div>
		</div>
		<el-dialog title="设置条码" :visible.sync="customCodeDailog" width="30%" :modal-append-to-body="false" :close-on-click-modal="false">
			<el-form :model="customCodeParams" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="条码" prop="name">
					<span>{{customCodeParams.goodsCustomCode}}</span>
					<!-- <el-input v-model="customCodeParams.goodsCustomCode"></el-input> -->
				</el-form-item>
				<el-form-item label="条码状态:">
					<el-select size="medium" clearable class="input" v-model="customCodeParams.customCodeStatus" placeholder="选择条码状态">
						<el-option :label="item.lable" :value="Number(item.value)" v-for="item in customCodeStatus" :key="item.label"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="初始门店:">
					<el-select size="medium" clearable v-model="customCodeParams.fromShopId" placeholder="选择门店">
						<el-option :label="item.shop_name" :value="item.shop_id" v-for="item in $store.state.userInfo.shops" :key="item.shop_id"></el-option>
					</el-select>
					<div class="tip m-l-10 f-12 color-969799">若为空考虑初始门店为总仓</div>
				</el-form-item>
				<el-form-item label="所在门店:">
					<span>{{customCodeParams.currentShopName}}</span>
				</el-form-item>
				<el-form-item label="去往的门店:">
					<el-select size="medium" clearable v-model="customCodeParams.toShopId" placeholder="选择门店">
						<el-option :label="item.shop_name" :value="item.shop_id" v-for="item in $store.state.userInfo.shops" :key="item.shop_id"></el-option>
					</el-select>
					<div class="tip m-l-10 f-12 color-969799">若为空考虑状态为调拨中</div>
				</el-form-item>

				<el-form-item label="条码总次数" prop="name">
					<el-input style="width:150px" v-model="customCodeParams.totaTimes"></el-input>
				</el-form-item>
				<el-form-item label="已使用次数" prop="name">
					<el-input style="width:150px" v-model="customCodeParams.useTimes"></el-input>
				</el-form-item>
				<el-form-item label="有效期" prop="name">
					<el-date-picker v-model="customCodeParams.validityStopDate" type="date" format="yyyy-MM-dd" value-format="timestamp"
					placeholder="选择日期"></el-date-picker>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-tooltip class="item" effect="dark" content="请谨慎设置条码信息" placement="top">
					<el-button type="warning" @click="submitCustom" size="small">确 定</el-button>
				</el-tooltip>

			</span>
		</el-dialog>

		<el-dialog title="条码拆分" :visible.sync="codeinfoSplitDailog" width="30%" :modal-append-to-body="false" :close-on-click-modal="false">
			<el-form :model="splitCustomCodeParams" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="条码" prop="name">
					<span>{{splitCustomCodeParams.goodsCustomCode}}</span>
				</el-form-item>


				<el-form-item label="去往的门店:">
					<el-select size="medium" clearable v-model="splitCustomCodeParams.useShopId" placeholder="选择门店">
						<el-option :label="item.shop_name" :value="item.shop_id" v-for="item in $store.state.userInfo.shops" :key="item.shop_id"></el-option>
					</el-select>
					<div class="tip m-l-10 f-12 color-969799">选择拆分的条码去往的门店</div>
				</el-form-item>

				<el-form-item label="条码剩余次数" prop="name">
					<span>{{splitCustomCodeParams.totaTimes}}</span>
				</el-form-item>
				<el-form-item label="拆分次数" prop="name">
					<el-input style="width:150px" v-model="splitCustomCodeParams.splitTimes"></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-tooltip class="item" effect="dark" content="请谨慎设置条码信息" placement="top">
					<el-button type="warning" @click="submitSplitCustom" size="small">确 定</el-button>
				</el-tooltip>

			</span>
		</el-dialog>
	</div>
</template>
<script>
	import printJs from "../../../util/print.js"
	export default {
		data() {
			return {
				customCodeDailog: false,
				titleBtn: "收起筛选",
				screenShow: true,
				select: 1,
				selectfun: false,
				multipleSelection: [],
				customCodeStatus: [{
						lable: "已退货",
						value: "-1"
					},
					{
						lable: "已报废",
						value: "-2"
					},
					{
						lable: "已内耗",
						value: "-3"
					},
					{
						lable: "已损耗",
						value: "-4"
					},
					{
						lable: "已丢失",
						value: "-5"
					},
					{
						lable: "未入库",
						value: "0"
					},
					{
						lable: "已入库",
						value: "1"
					},
					{
						lable: "未使用",
						value: "2"
					},
					{
						lable: "使用中",
						value: "3"
					},
					{
						lable: "调拨中",
						value: "6"
					},
					{
						lable: "已销售",
						value: "9"
					}
				],
				params: {
					keywords: "",
					pageIndex: 1,
					pageSize: 10,
					customCodeStatus: "",
					ShopId: ""
				},
				goodData: {},
				rowItemDetail: [{
					trackDesc: "11",
					trackTime: "1596701679"
				}],
				selectCustomData: [],
				srcData: "",
				customCodeParams: {
					goodsCustomCode: "",
					goodsId: null,
					skus: null,
					validityStopDate: "",
					totaTimes: 0,
					useTimes: 0,
					customCodeStatus: 0,
					fromShopId: "",
					toShopId: "",
				},
				codeinfoSplitDailog: false,
				splitCustomCodeParams: {
					goodsCustomCode: '',
					splitTimes: 0,
					useShopId: '',

				}
			};
		},
		created() {
			this.getGoods();
			console.log(this.$store.state.allShopList)
		},
		methods: {
			//展开/收起筛查条件
			toggleShow() {
				this.screenShow = !this.screenShow;
				if (this.screenShow) {
					this.titleBtn = "收起筛选";
				} else {
					this.titleBtn = "展开筛选";
				}
			},
			//table选中
			handleSelectionChange(val) {
				console.log(val);
				if (val.length > 0) {
					this.selectfun = true;
				} else {
					this.selectfun = false;
				}
				this.multipleSelection = val;
			},
			//table操作编辑
			handleEdit(id) {
				this.$router.push({
					name: "addgoods-stock",
					query: {
						id: id
					}
				});
			},


			handleCurrentChange(val) {
				this.params.pageIndex = val;
				this.getGoods();
			},
			//筛选
			searchGoods() {
				this.params.pageIndex = 1;
				this.goodData = [];
				this.getGoods();
			},
			//重置筛选
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			//获取商品列表
			getGoods() {
				this.$http.post(process.env.VUE_APP_kucun + '/api/Goods/CustomCode/List',this.params).then(res => {
					console.log(res)
					if (res.code == 0) {
						console.log("商品一维一码信息", res.data.data)
						this.goodData = res.data;
						this.goodData.data.map(item => {
							item["rowItemDetail"] = [];
						});
					}
				})
			},
			//去商品详情
			goGoodDl(id) {
				this.$router.push({
					name: "goodsdetails-stock",
					query: {
						id: id
					}
				});
			},
			goAddGoods() {
				this.$router.push({
					name: "addgoods-stock"
				});
			},
			toogleExpand(row) {
				console.log(row,row.customCode);
				let $table = this.$refs.table;
				this.$http.get(process.env.VUE_APP_kucun + '/api/Goods/track',{goodsCustomCode: row.customCode}).then(res => {
					console.log(res)
					if (res.code == 0) {
						console.log("输出追踪信息", res.data);
						row.rowItemDetail = res.data.goodsTrackInfo;
						$table.toggleRowExpansion(row);
						this.goodData.data.map(item => {
							if (row.customCode != item.customCode) {
								$table.toggleRowExpansion(item, false);
							}
						});
					}
				})
			},
			selectionChange(data) {
				console.log(data)
				this.selectCustomData = data.map(item => {

					return {
						code: Number(item.customCode),
						name: item.goodsName,
						sku: item.totaTimes > 1 ? `${item.skuValue}/${item.totaTimes}次` : item.skuValue,
						unit: item.unit
					};
				});
				console.log(this.selectCustomData)
			},
			printCustom(customArray) {
				if (!customArray.length) {
					this.$message.error("请选择条码进行打印");
				} else {
					
					// let isInterval = customArray.some(item => {
					// 	return 100000000000 === item.code
					// })

					let params = {
						bar_codes: customArray
					}
					printJs.printTicketBarCode(params.bar_codes).then(res=>{
						this.$store.commit("set_printUrl",res.msg)
					})
					// if (isInterval) {
					// 	shopPrint(JSON.stringify(params)).then(data => {
					// 		if (data.url != "") {
					// 			this.srcData = `ChuLinPrint:${data.url}`;
					// 		}
					// 	});
					// } else {
						// print(JSON.stringify(params)).then(data => {
						// 	if (data.url != "") {
						// 		this.srcData = `ChuLinPrint:${data.url}`;
						// 	}
						// });
					// }

				}
			},
			editCustomCode(row) {
				this.customCodeDailog = true;
				this.customCodeParams = {
					goodsCustomCode: row.customCode,
					goodsId: row.goodsId,
					skus: row.skus,
					validityStopDate: row.validityStopDate != 0 ? row.validityStopDate * 1000 : "",
					totaTimes: row.totaTimes,
					useTimes: row.useTimes,
					customCodeStatus: row.customCodeStatus.id,
					fromShopId: row.fromShopId,
					toShopId: row.toShopId,
					currentShopName: row.currentShopName,
				};
			},
			submitCustom() {
				this.customCodeParams.validityStopDate = this.customCodeParams.validityStopDate ? this.customCodeParams.validityStopDate /
					1000 : null,
					this.$http.post(process.env.VUE_APP_kucun + '/api/Goods/update/codeinfo',this.customCodeParams).then(res => {
					  console.log(res)
						if (res.code == 0) {
							this.$message({
								type: "success",
								message: "设置成功!"
							});
							this.customCodeDailog = false;
							this.getGoods();
						}
					})
			},

			lostCustom(customArray) {
				if (!customArray.length) {
					this.$message.error("请选择条码进行丢弃");
				} else {
					let params = customArray.map(item => {
						return item.code
					})
					
					this.$http.post(process.env.VUE_APP_kucun + '/api/Goods/update/loststatus',params).then(res => {
						if (res.code == 0) {
							this.$message({
								type: "success",
								message: "设置成功!"
							});
							this.getGoods();
						}
					})
				}
			},
			reductionCustom(customArray) {
				if (!customArray.length) {
					this.$message.error("请选择条码进行还原");
				} else {
					let params = customArray.map(item => {
						return item.code
					})
					
					this.$http.post(process.env.VUE_APP_kucun + '/api/Goods/update/lostrecoverystatus',params).then(res => {
						if (res.code == 0) {
							this.$message({
								type: "success",
								message: "设置成功!"
							});
							this.getGoods();
						}
					})
				}
			},
			splitCustomCode(row) {
				this.codeinfoSplitDailog = true;
				this.splitCustomCodeParams = {
					goodsCustomCode: row.customCode,
					splitTimes: 1,
					useShopId: '',
					totaTimes: row.totaTimes - row.useTimes
				};
			},
			submitSplitCustom() {
				let loading = this.$loading()
				
				this.$http.post(process.env.VUE_APP_kucun + '/api/Goods/codeinfo/split',this.splitCustomCodeParams).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							type: "success",
							message: `条码拆分成功.新条码为${res.data}`
						});
						this.codeinfoSplitDailog = false;
						this.getGoods();
					}
				})
			},
			

		},
		
	};
</script>
<style lang="scss" scoped>
	.page-good {
		
	.titleView {
		background: #fff;
		height: 72px;
		display: flex;
		align-items: center;
		font-size: 14px;
		padding: 0 10px;
		.mr{
			margin-right: 10px;
		}
	}
		.wrapper {
			height: 100%;
			display: flex;
			flex-direction: column;
			.fun {
				margin-bottom: 10px;
				.iconsousuo {
					font-size: 14px;
				}

				.el-input-group__append {
					background-color: #42b983;
					border: 1px solid #42b983;
					color: #fff;
					font-size: 14px;
				}
			}

			.screen {
				margin-top: 10px;
				box-shadow: 1px 1px 5px rgba(228, 228, 228, 1);
				padding: 10px 20px;

				.input {
					width: 140px;
				}

				.itemform {
					width: 300px;
				}
			}
			.table{
				flex: 1;
				background: #fff;
			}
		}
	}
	
	.row-expand-cove .el-table__expand-icon {
		display: none;
	}
</style>
